import React from "react";
import { useLocation, Link } from "react-router-dom";
import styled from "styled-components";
import { useRef, useEffect, useState } from "react";
import { use } from "react";
import Header from "../components/Header";
const ReactDOMServer = require("react-dom/server");
const HtmlToReactParser = require("html-to-react").Parser;

const Wrapper = styled.div`
  position: relative;
  height: 100vh;
  width: 100vw;
  background-color: black;
  overflow: hidden;
  cursor: pointer;
`;

const BgImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
`;

const TextWrapper = styled.div`
  position: absolute;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  user-select: none; /* Standard */
  z-index: 1;
`;

const Title = styled.div`
  max-width: 80vw;
  width: max-content;
  text-align: center;
  font-family: cool;
  font-size: 2em;
  line-height: 1;
  // font-weight: 100;
  text-transform: uppercase;
  color: white;
  z-index: 100;
  cursor: help;
  text-shadow: 0px 0px 5px black;
  letter-spacing: 0.8px;
`;

const Quote = styled(Title)`
  font-size: 2em;
  font-weight: bold;
  white-space: pre-wrap;

  @media (max-width: 600px) {
    font-size: 2em;
  }
`;
const Credits = styled(Title)`
  font-size: 1.5em;
  // line-height: 2.2;
  white-space: pre-wrap;
  font-weight: 0;
  @media (max-width: 600px) {
    font-size: 1.5em;
  }
`;

const Name = styled(Title)`
  font-family: Roumald;
  font-size: 2em;
  text-transform: lowercase;
  cursor: pointer;
`;

// Resolves only once the browser has fully decoded the image, so swapping
// the background never shows a blank/white frame mid-decode.
function preloadImage(src) {
  return new Promise((resolve) => {
    if (!src) return resolve(null);
    const img = new Image();
    img.src = src;
    const done = () => resolve(img);
    if (img.decode) {
      img.decode().then(done).catch(done);
    } else {
      img.onload = done;
      img.onerror = done;
    }
  });
}

export default function Project() {
  const wrapperRef = useRef();
  const textWrapperRef = useRef();
  const titleRef = useRef();
  const typeRef = useRef();
  const yearRef = useRef();
  const roleRef = useRef();
  const quoteRef = useRef();
  const creditsRef = useRef();
  const headerRef = useRef();
  const location = useLocation();
  const { project } = location.state;
  const [image, setImage] = useState();
  const [imageIndex, setImageIndex] = useState(0);
  const [textIndex, setTextIndex] = useState(1);
  var refs = [titleRef, yearRef, typeRef, roleRef, creditsRef, headerRef];
  const preloadedRef = useRef([]);
  // Two stacked <img> layers we crossfade between, so switching images
  // never relies on a background-image swap (which can flash white on
  // WebKit while the GPU uploads the new texture).
  const layerARef = useRef();
  const layerBRef = useRef();
  const activeLayerRef = useRef("A");

  useEffect(() => {
    clearRefs();
  }, []);

  // Preload + fully decode every slide up front, keeping references so
  // Safari doesn't garbage-collect (and abort) the in-flight loads.
  useEffect(() => {
    let cancelled = false;
    Promise.all(project.images.map(preloadImage)).then((imgs) => {
      if (!cancelled) preloadedRef.current = imgs;
    });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project]);

  useEffect(() => {
    const src = project.images[imageIndex];
    if (!src) return;

    const showingA = activeLayerRef.current === "A";
    const activeEl = showingA ? layerARef.current : layerBRef.current;
    const nextEl = showingA ? layerBRef.current : layerARef.current;
    if (!nextEl || (activeEl && activeEl.src === src)) return;

    const reveal = () => {
      nextEl.style.opacity = "1";
      if (activeEl) activeEl.style.opacity = "0";
      activeLayerRef.current = showingA ? "B" : "A";
      console.log("image " + imageIndex + " of " + project.images.length);
    };

    if (nextEl.src === src && nextEl.complete) {
      reveal();
    } else {
      nextEl.onload = reveal;
      nextEl.src = src;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageIndex]);

  function clearRefs() {
    for (let i = 0; i < refs.length; i++) {
      if (refs[i].current.innerHTML == "") {
        refs.splice(i, 1);
        console.log("removed ref");
        console.log(refs);
      }
    }
  }

  function changeText(e) {
    e.stopPropagation();
    console.log(refs);
    for (let i = 0; i < refs.length; i++) {
      refs[i].current.style.display = "none";
    }
    if (textIndex < refs.length - 1) {
      setTextIndex(textIndex + 1);
    } else {
      setTextIndex(1);
    }
    refs[textIndex].current.style.display = "block";
    if (textIndex == 1) {
      refs[2].current.style.display = "block";
      refs[3].current.style.display = "block";
      setTextIndex(4);
    }
  }

  function changeImage(e) {
    e.stopPropagation();
    //  console.log("image index at click: " + imageIndex);
    if (
      imageIndex + 1 <= project.images.length &&
      project.images[imageIndex + 1]
    ) {
      setImageIndex(imageIndex + 1);
    } else {
      console.log("no image");
      setImageIndex(0);
    }
  }

  // parse HTML from WP API to React element
  const htmlToReactParser = new HtmlToReactParser();
  const reactElement = htmlToReactParser.parse(project.abstract);

  return (
    <Wrapper ref={wrapperRef}>
      <BgImage
        ref={layerARef}
        src={project.images[0]}
        alt=""
        style={{ opacity: 1 }}
      />
      <BgImage ref={layerBRef} alt="" style={{ opacity: 0 }} />
      <TextWrapper ref={textWrapperRef} onClick={changeImage}>
        <Title ref={titleRef} onClick={changeText}>
          {project.title}
        </Title>

        <Title ref={typeRef} style={{ display: "none" }} onClick={changeText}>
          {project.type}
        </Title>

        <Quote ref={quoteRef} style={{ display: "none" }} onClick={changeText}>
          {project.quote}
        </Quote>

        <Title ref={yearRef} style={{ display: "none" }} onClick={changeText}>
          {project.location} {project.year}
        </Title>

        <Title ref={roleRef} style={{ display: "none" }} onClick={changeText}>
          {project.role}
        </Title>

        <Credits
          ref={creditsRef}
          style={{ display: "none" }}
          onClick={changeText}
        >
          {project.credits}
        </Credits>
        <Link to="/" style={{ textDecoration: "none" }}>
          <Name
            ref={headerRef}
            style={{ display: "none" }}
            onClick={changeText}
          >
            nina kunzendorf
          </Name>
        </Link>
      </TextWrapper>
    </Wrapper>
  );
}
